import { library } from '@fortawesome/fontawesome-svg-core';

// Pro light
import {
  faLockAlt,
  faEnvelope,
  faTimesCircle,
  faCheckCircle,
  faExclamationCircle,
  faUserHeadset,
  faTachometerSlow,
  faStoreAlt,
  faUser,
  faSlidersH,
  faAddressBook,
  faCommentsDollar,
  faFileCheck,
  faBars,
  faPhone,
  faLink,
  faEye,
  faEyeSlash,
  faCircle,
  faCheck,
  faCheckDouble,
  faChevronCircleDown,
  faChevronRight,
  faChevronLeft,
  faClock,
  faEllipsisV,
  faCalendarAlt,
  faPlus,
  faEdit,
  faTrashAlt,
  faPlusCircle,
  faSignOut,
  faClipboardListCheck,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faExchangeAlt,
  faUserCheck,
  faHourglassHalf,
  faHandHoldingUsd,
  faCopyright,
  faMapMarkedAlt,
  faInfoCircle,
  faCog,
  faDoorOpen,
  faUserFriends,
  faFileImage,
  faFilePdf,
  faFileWord,
  faFile,
  faFileAlt,
  faFileUpload,
  faUserTag,
  faCashRegister,
  faCloudUpload,
  faBoxes,
  faPiggyBank,
  faExternalLink,
  faKey,
  faSearch,
  faQuestionCircle,
  faUsersCog,
  faMinusCircle,
  faCommentDots,
  faMoneyCheckAlt,
  faFileInvoiceDollar,
  faChartLine,
  faArchive,
  faBan,
  faUserSlash,
  faHistory,
  faAngleDown,
  faAngleUp,
  faSave,
  faClipboardCheck,
  faReceipt,
  faDollarSign,
  faCoins,
  faChartNetwork,
  faShieldCheck,
  faBullseyeArrow,
  faBalanceScale,
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons';

// Pro solid NOTE: We have to alias some of these because they clash with the non-solid
import {
  faPennant,
  faStar,
  faUserCircle,
  faIdBadge,
  faTimesSquare,
  faAsterisk,
  faCaretDown,
  faFlag,
  faSpinner,
  faFileContract as fasFileContract,
  faCheckCircle as fasCheckCircle,
  faMinusCircle as fasMinusCircle,
  faPlusCircle as fasPlusCircle,
  faExclamationCircle as fasExclamationCircle,
} from '@fortawesome/pro-solid-svg-icons';

// Pro regular
import {
  faSignature,
  faFileContract,
} from '@fortawesome/pro-regular-svg-icons';

library.add(
  faLockAlt,
  faEnvelope,
  faTimesCircle,
  faCheckCircle,
  faMinusCircle,
  fasMinusCircle,
  faExclamationCircle,
  fasExclamationCircle,
  faUserHeadset,
  faTachometerSlow,
  faStoreAlt,
  faUser,
  faSlidersH,
  faAddressBook,
  faCommentsDollar,
  faFileCheck,
  faUserCircle,
  faBars,
  faPhone,
  faLink,
  faEye,
  faEyeSlash,
  faCircle,
  faCheck,
  faCheckDouble,
  faChevronCircleDown,
  faChevronRight,
  faChevronLeft,
  faPennant,
  faClock,
  faEllipsisV,
  faStar,
  faCalendarAlt,
  faPlus,
  faIdBadge,
  faEdit,
  faTrashAlt,
  faPlusCircle,
  faTimesSquare,
  faSignature,
  faFileContract,
  fasFileContract,
  faSignOut,
  faClipboardListCheck,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faExchangeAlt,
  faUserCheck,
  faHourglassHalf,
  faHandHoldingUsd,
  faCopyright,
  faMapMarkedAlt,
  faAsterisk,
  faCaretDown,
  faInfoCircle,
  faCog,
  faDoorOpen,
  faUserFriends,
  faFileImage,
  faFilePdf,
  faFileWord,
  faFile,
  faFileAlt,
  faFileUpload,
  faFlag,
  faSpinner,
  faUserTag,
  faCashRegister,
  faCloudUpload,
  fasCheckCircle,
  faBoxes,
  faPiggyBank,
  faExternalLink,
  faKey,
  faSearch,
  faQuestionCircle,
  faUsersCog,
  fasPlusCircle,
  faCommentDots,
  faMoneyCheckAlt,
  faFileInvoiceDollar,
  faChartLine,
  faArchive,
  faBan,
  faUserSlash,
  faHistory,
  faAngleDown,
  faAngleUp,
  faSave,
  faClipboardCheck,
  faReceipt,
  faDollarSign,
  faCoins,
  faChartNetwork,
  faShieldCheck,
  faBullseyeArrow,
  faBalanceScale,
  faExclamationTriangle
);
